var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.536,41.579V25.853h2.029c1.104,0,2-0.896,2-2s-0.896-2-2-2h-2.029H38.463h-2.029c-1.104,0-2,0.896-2,2s0.896,2,2,2 h2.029v15.726c-4.486,3.123-7.131,8.145-7.131,13.652c0,9.19,7.477,16.668,16.667,16.668s16.667-7.478,16.667-16.668 C64.667,49.723,62.022,44.7,57.536,41.579z M48,67.898c-6.985,0-12.667-5.683-12.667-12.668c0-4.476,2.303-8.532,6.161-10.851 l0.97-0.583V25.853h11.073v17.944l0.97,0.583c3.858,2.318,6.161,6.375,6.161,10.851C60.667,62.216,54.984,67.898,48,67.898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.758,47.793c-2.928,0-5.31,2.382-5.31,5.31s2.382,5.31,5.31,5.31s5.31-2.382,5.31-5.31S55.686,47.793,52.758,47.793z  M52.758,54.412c-0.722,0-1.31-0.588-1.31-1.31s0.588-1.31,1.31-1.31s1.31,0.588,1.31,1.31S53.479,54.412,52.758,54.412z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.015,58.491c-1.709,0-3.101,1.391-3.101,3.101s1.391,3.101,3.101,3.101s3.101-1.391,3.101-3.101 S45.725,58.491,44.015,58.491z M44.015,62.491c-0.496,0-0.899-0.403-0.899-0.899s0.403-0.899,0.899-0.899s0.899,0.403,0.899,0.899 S44.511,62.491,44.015,62.491z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.ccc13a42a6d2115b62501c4b89e68a01.svg";
export { ForwardRef as ReactComponent };